import React from "react";
import { ReactComponent as Quote } from "design_system/src/static/icons/quotes.svg";
import { ScalableImage, Typography } from "design_system/src";
import styles from "./TestimonialCard.module.scss";


export interface TestimonialData {
  comment: string;
  name: string;
  role: string;
  imageUrl: string;
  margin?: boolean;
  small?: boolean;
  alignEnd?: boolean;
}

interface TestimonialCardProps {
  data: TestimonialData;
  small?: boolean;
  margin?: boolean;
}

const TestimonialCard = ({ data, small = false, margin = false }: TestimonialCardProps) => {
  const { comment, name, role, imageUrl } = data;

  return (
    <div
      className={`${styles.TestimonialCard}${small ? ` ${styles["TestimonialCard--small"]}` : ""}${margin ? ` ${styles["TestimonialCard--margin"]}` : ""}`}
    >
      <Quote
        className={`${styles.TestimonialCardQuote}${small ? ` ${styles["TestimonialCardQuote--small"]}` : ""}`}
      />
      <div
        className={`${styles.TestimonialCardTextContainer}${small ? ` ${styles["TestimonialCardTextContainer--small"]}` : ""}`}
      >
        <div
          className={`${styles.TestimonialCardText}${small ? ` ${styles["TestimonialCardText--small"]}` : ""}`}
        >
          <Typography weight="400" scale={small ? "xsmall" : "small"}>“{comment}”</Typography>
        </div>
        <div className={styles.TestimonialCardAuthor}>
          <Typography weight="600" scale="medium">{name}</Typography>
          <Typography weight="400" scale="xsmall">{role}</Typography>
        </div>
      </div>
      <ScalableImage
        className={`${styles.TestimonialCardImage}${small ? ` ${styles["TestimonialCardImage--small"]}` : ""}`}
        src={imageUrl}
        desktopWidth={10}
        mobileWidth={10}
        alt={`Testimonio de cliente Ozon – ${name}`}
      />
    </div>
  );
};

export default TestimonialCard;
